// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 522) return "static/css/522.684473c2fda97e2736bb.lib.css";
	if (chunkId === 296) return "static/css/296.fe0a4b604bef64b73d04.css";
	// return url for filenames based on template
	return undefined;
};